// extracted by mini-css-extract-plugin
module.exports = {"spin":"_2iZPLUTN-GiIn1MHDQazkE"};